import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import SidebarHeader from '../components/SidebarHeader';
import { ALERT_SIDEBAR_TABS } from './modules/tabConfig';
import Connector, { PropsFromRedux } from './Connector';
import { AlertSidebarWrapper } from '../styled';
import { useDocumentVisibility } from 'src/utils/hooks/useDocumentVisibility';
import permissions from 'src/permissions';
import { hasAnyPermissions } from 'src/utils/permissions';
import { appRoutes } from 'src/routes/Root/modules/routesUtils';

type Props = PropsFromRedux & RouteComponentProps;

const AlertSidebar = ({
  activeTab,
  changeSidebarTab,
  onMount,
  onUnmount,
  fetchHistoricalAlerts,
  match,
}: Props) => {
  const isDocumentVisible = useDocumentVisibility();

  useEffect(() => {
    if (!isDocumentVisible) {
      return;
    }
    onMount();
    fetchHistoricalAlerts([]);
    return () => {
      onUnmount();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDocumentVisible]);

  if (match.path === `/:locale/${appRoutes.INDIVIDUAL_DASHBOARD}`) {
    return null;
  }

  return hasAnyPermissions(
    permissions.VIEW_CURRENT_ALERTS,
    permissions.VIEW_EVENT_LOG,
  ) ? (
    <AlertSidebarWrapper data-cy="alerts-sidebar">
      <SidebarHeader
        tabKey={activeTab}
        tabConfig={ALERT_SIDEBAR_TABS}
        onChangeTab={id => {
          changeSidebarTab(id as typeof activeTab);
        }}
      />
      {hasAnyPermissions(...ALERT_SIDEBAR_TABS[activeTab].permission) ? (
        ALERT_SIDEBAR_TABS[activeTab].render()
      ) : (
        <></>
      )}
    </AlertSidebarWrapper>
  ) : (
    <></>
  );
};

export default Connector(AlertSidebar);
